module.exports = __webpack_public_path__ + "static/images/4251ddf2d56f5e2e16f35d73cff7b482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sure.png
// module id = 443
// module chunks = 20 23 24